import { useState, useMemo } from "react";
import { useGetDealerRolesUsersByFirmIDQuery } from "../../store/dealerRoles/firmApi";

export function useFirmUsersData({ id, token }) {
  const [paginationNumber, setPaginationNumber] = useState(1);

  const queryArg = useMemo(() => (id && token ? { id, token } : null), [id, token]);

  const {
    data: usersData,
    isLoading: usersIsLoading,
    isFetching: usersIsFetching,
    error: usersError,
    refetch: refetchFirmUsers,
  } = useGetDealerRolesUsersByFirmIDQuery(
    queryArg,
    {
      refetchOnMountOrArgChange: false,
      skip: !queryArg,
    }
  );

  const users = useMemo(() => usersData?.data?.users || [], [usersData]);

  const isLoading = usersIsLoading || usersIsFetching;
  const hasNoData = usersData?.results === 0 || usersError;

  return {
    users,
    isLoading,
    hasNoData,
    usersError,
    paginationNumber,
    setPaginationNumber,
    refetch: refetchFirmUsers,
  };
}
